import React from 'react'
import { FormattedMessage } from 'react-intl'
import { TooltipLabel } from '../../../design-system'
import { TooltipLabelText } from './tooltip-label-text'

export function Technologies({
  technologies
}: {
  readonly technologies: string[]
}) {
  return (
    <FormattedMessage
      id="plural_technologies"
      values={{ count: technologies.length }}
    >
      {(label) => {
        return (
          <TooltipLabel
            label={label as any}
            renderValue={() => {
              return <TooltipLabelText children={technologies.join(', ')} />
            }}
          />
        )
      }}
    </FormattedMessage>
  )
}
